import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

export default function PhotoGeneratedImagePopup({ url, onClose, zIndex = 2500 }) {
  return (
    <AnimatePresence>
      {url && (
        <motion.div
          className="photo-sample-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          style={{ zIndex }}
        >
          <motion.div
            className="photo-sample-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="photo-sample-popup-header">
              <h3 className="photo-sample-popup-title">생성된 이미지</h3>
              <button className="photo-sample-popup-close" onClick={onClose}>
                <Icon icon="solar:close-circle-bold" width={20} height={20} />
              </button>
            </div>
            <div className="photo-sample-popup-content" style={{ alignItems: 'center' }}>
              <img
                src={url}
                alt="생성 결과"
                style={{ maxWidth: '100%', maxHeight: '60vh', borderRadius: '10px', background: '#111' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', margin: '24px 0 8px' }}>
              <button className="photo-sample-btn" style={{ fontWeight: 700, minWidth: 110 }} onClick={onClose}>
                다시 생성하기
              </button>
              <button
                className="photo-sample-btn"
                style={{ fontWeight: 700, minWidth: 110, textAlign: 'center' }}
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = 'generated-image.png';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                다운로드하기
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


